module.exports = __webpack_public_path__ + "img/extract.51ed00d1.png";